import React from 'react';
import { useForm, FormProvider, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import DeleteSectionButton from './../DeleteSectionButton';
import LastUpdatedAt from './../LastUpdatedAt';
import {IconDelete} from "./../../../assets/images/icons"
import {
  ErrorMessage,
  TextInput,
  RichTextInput,
  HookFormDirtyCheck,
} from "../../react-hook-form-inputs";
import './../OfferForm.scss';

const TractionSchema = Yup.object().shape({
  content: Yup.object()
    .test(
      'has text',
      'Article content is required',
      value => value && value.getCurrentContent().getPlainText().replace(/\s/g, '').length > 0
    ),
  points: Yup.array()
    // .of(Yup.string().required("Can't be blank"))
    .of(Yup.object().shape({
      value: Yup.string().required("Traction point is required")
    }))
    .required('Must have tractios points') // these constraints are shown if and only if inner constraints are satisfied
    .min(1, 'Minimum of 1 traction point')
    .max(5, 'Maximum of 5 traction point'),
  });

export default function TractionForm({
  pitch:{traction_section={}, pitchable_id}, pitchableType, pitchableId, updatePitchMutation
}) {
  if(traction_section === null) traction_section = {};

  const defaultValues = {
    content: RichTextInput.createState(traction_section.content),
    points: traction_section.points?.map(t=> ({value: t})) || [],
  }

  const methods = useForm({
    resolver: yupResolver(TractionSchema),
    mode: "all",
    reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    criteriaMode: "firstError",
    defaultValues: defaultValues
  });

  React.useEffect(() => {
    methods.setValue("content", RichTextInput.createState(traction_section.content || ""));
    methods.setValue("points", traction_section.points?.map(t=> ({value: t})) || []);
  }, [methods, traction_section]);

  const onSubmit = values => {
    const { points, content} = values
    updatePitchMutation.mutate({
      pitchable_type: pitchableType,
      pitchable_id: pitchableId,
      values: {
        pitch: {
          traction_section_attributes: {
            points: points.map(p => p.value).filter(Boolean),
            content: RichTextInput.contentForSave(content),
          }
        }
      }
    })
  }

  const { fields, append, remove } = useFieldArray(
    {
      control: methods.control,
      name: "points",
      keyName: "key",
    }
  );

  const countTractionPoints = methods.watch("points").length
  const {errors} = methods.formState;

  return(
    <div id="tractionForm">
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)} className="mt-1">
          <div className="col-xs-12 row">
            <div className="col-lg-7">
              <label className="mb-1">Article content</label>
              <RichTextInput name="content" hideExternalPlugins={false} containerStyle={{ height: "400px"}}/>
            </div>
            <div className="col-lg-5">
              <label className="mb-1">Traction points</label>
              {
                fields.map((point, index) => (
                  <div className="row d-flex align-items-center" key={point.key}>
                    <div className="form-floating col-md-11">
                      <TextInput
                        name={`points[${index}].value`}
                        placeholder="Traction point"
                      />
                    </div>
                    <div className="col-md-1">
                      <img src={IconDelete} onClick={() => remove(index)} className="cursor-pointer" alt="ms-0 close icon" height="24px"/>
                    </div>
                  </div>
                ))
              }
              <ErrorMessage error={errors.points || {}} />
              {
                countTractionPoints < 5 &&
                  <span onClick={() => append({value: ""})} className="cursor-pointer fs-10 d-block">
                    + Add new point
                  </span>
              }
            </div>
          </div>
          <div className="form-group mt-3">
            <button type="submit"
              className="mx-auto btn btn-outline-dark rounded-0"
              disabled={methods.isSubmitting}
            >
              Save Section
            </button>
            <DeleteSectionButton pitchableType={pitchableType} pitchableId={pitchableId} sectionId={traction_section.id} sectionType="traction"/>
            <LastUpdatedAt updatedAt={ traction_section.updated_at }/>
            <HookFormDirtyCheck />
          </div>
        </form>
      </FormProvider>
    </div>
  );
}
